const DEFAULT_DURATION = 3;
const SPLASH_ID = "app-splash-cover";
const splashEnv = String(import.meta.env.VITE_APP_SPLASH ?? "").trim();
const SPLASH_ENABLED = (splashEnv || (import.meta.env.DEV ? "0" : "1")) !== "0";

function resolveDuration(duration) {
    const seconds = Number(duration);
    return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
}

export function showAppSplash(duration = DEFAULT_DURATION) {
    if (!SPLASH_ENABLED || typeof document === "undefined" || document.getElementById(SPLASH_ID)) {
        return;
    }

    const seconds = resolveDuration(duration);
    const cover = document.createElement("div");
    cover.id = SPLASH_ID;
    cover.className = "m-app-splash";
    cover.setAttribute("role", "presentation");
    cover.style.cssText = [
        "position:fixed",
        "inset:0",
        "z-index:99999",
        "width:100vw",
        "height:100vh",
        "height:100dvh",
        "display:flex",
        "align-items:center",
        "justify-content:center",
        "overflow:hidden",
        "background:#f7f8fa",
        "touch-action:none",
    ].join(";");

    const title = document.createElement("div");
    title.className = "u-app-splash-title";
    title.textContent = import.meta.env.VITE_APP_TITLE || "Suplasercut";
    title.style.cssText = [
        "font-size:32px",
        "font-weight:700",
        "letter-spacing:0",
        "color:#111827",
        "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
    ].join(";");

    const button = document.createElement("button");
    button.className = "u-app-splash-skip";
    button.type = "button";
    button.style.cssText = [
        "position:absolute",
        "right:max(20px, env(safe-area-inset-right))",
        "bottom:calc(max(20px, env(safe-area-inset-bottom)) + 4px)",
        "min-width:84px",
        "height:36px",
        "border:0",
        "border-radius:18px",
        "padding:0 16px",
        "background:rgba(17, 24, 39, 0.48)",
        "color:#fff",
        "font-size:14px",
        "line-height:36px",
        "white-space:nowrap",
        "backdrop-filter:blur(10px)",
    ].join(";");

    cover.append(title, button);
    document.body.appendChild(cover);

    const endsAt = Date.now() + seconds * 1000;
    let timer = null;
    let ticker = null;

    const updateRemainingSeconds = () => {
        const remaining = Math.max(0, endsAt - Date.now());
        button.textContent = `跳过 ${Math.ceil(remaining / 1000)}s`;
    };

    const hide = () => {
        if (timer) {
            window.clearTimeout(timer);
            timer = null;
        }
        if (ticker) {
            window.clearInterval(ticker);
            ticker = null;
        }
        cover.style.transition = "opacity 0.24s ease";
        cover.style.opacity = "0";
        window.setTimeout(() => {
            cover.remove();
        }, 240);
    };

    button.addEventListener("click", hide);
    updateRemainingSeconds();
    ticker = window.setInterval(updateRemainingSeconds, 250);
    timer = window.setTimeout(hide, Math.round(seconds * 1000));
}
